import {Text} from '@eitje/web_components'
import {ftime} from '@eitje/utils'

export const DateRow = ({item}) => {
	return (
		<>
			<Text t={`records.default.fields.${item.description}`} infoIconMessage={item.infoIconMessage} />
			<Text>{ftime(item.value, item.format || 'dayMonthYear')}</Text>
		</>
	)
}
